<div class="layout-column custom-panel table-column-picker">
  <div class="layout-row layout-align-start-center gap-5 padding-10">
    <bz-search-input class="flex"
                     appBringozIdGenerator="table_column_picker_search"
                     [debounceMs]="0"
                     [placeholder]="'Search Columns' | translate"
                     (valueChange)="onQueryChange($event)">
    </bz-search-input>
    @if (data.currentColumn) {
      <div ngbTooltip="{{'Hide Column' | translate}}" container="body">
        <bringoz-button type="tertiary"
                        size="fit"
                        appBringozIdGenerator="table_column_picker_hide"
                        [attr.aria-label]="'Hide Column' | translate"
                        (onClick)="hide()">
          <bringoz-icon iconName="trash" size="sm"></bringoz-icon>
        </bringoz-button>
      </div>
    }
  </div>
  <div class="table-column-picker-list">
    @for (section of filteredSections(); track section.title) {
      <div class="padding-top-10 padding-left-10 padding-right-10 padding-bottom-5 br-body-2 font-weight-600 gray-100">{{ section.title | translate }}</div>
      @for (option of section.options; track option.group + option.key) {
        <button type="button"
                class="table-column-picker-item br-body-2 gray-100"
                appBringozIdGenerator="table_column_picker_item"
                (click)="insert(option)">
          {{ option.labelKey | translate }}
        </button>
      }
    } @empty {
      <div class="padding-10 br-body-2 gray-100" translate>No Columns Found</div>
    }
  </div>
</div>
